import React from 'react';

export type InitiativeThreeSectionProps = {
  className?: string;
};

const InitiativeThreeSection: React.FC<InitiativeThreeSectionProps> = ({
  className = '',
}) => {
  return (
    <div className={`bg-white w-full ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="space-y-6">
          <div className="space-y-2">
            <p className="text-sm font-semibold text-teal-600 uppercase tracking-wide">Initiative Three</p>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              <span className="flex items-center">
                Ideas incubator
                <span className="ml-4 inline-block rounded-full bg-teal-200 text-teal-700 text-sm font-semibold px-2 py-1 align-middle">Coming soon</span>
              </span>
            </h2>
            <p className="text-lg font-semibold text-gray-700 leading-relaxed py-2">
              We're building an incubator to shape and support the future of AI-driven ideas. Stay tuned.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InitiativeThreeSection; 